import { Box, Text, useClassNames } from '@factorialco/deprecated-design-system'

import 'modules/project_management/components/Schedule/Body/ScheduleItem/index.styles.css'
import { stylesRefs } from 'modules/project_management/components/Schedule/Body/ScheduleItem/stylesRefs'
import { ScheduleRecordValuesType } from 'modules/project_management/components/Schedule/Body/ScheduleItem/types'
import {
  cellText,
  gridColumnSpan,
} from 'modules/project_management/components/Schedule/Body/ScheduleItem/utils'
import HoverScheduleCard from 'modules/project_management/components/Schedule/HoverScheduleCard'

import {
  SubRowCellHoverContent,
  SubRowCellHoverFooterDates,
  SubRowCellHoverFooterWeekDays,
  SubRowCellHoverHeader,
} from './SubRowCellHover'

interface ISubRowCellProps {
  span: number
  record?: ScheduleRecordValuesType
  openSidepanel: (data?: ScheduleRecordValuesType | null) => void
}

const SubRowCell = ({ span = 1, record, openSidepanel }: ISubRowCellProps) => {
  const cx = useClassNames(stylesRefs)

  const onClickSubRowCell = () => {
    if (record?.projectWorkerId === undefined || !record?.canEditAssignments) {
      return
    }
    openSidepanel(record)
  }

  return (
    <Box padding="s8" className={cx('scheduleItemCell')} style={{ ...gridColumnSpan(span) }}>
      {record?.dailyMinutes && (
        <HoverScheduleCard
          header={<SubRowCellHoverHeader record={record} />}
          content={<SubRowCellHoverContent record={record} />}
          moreContent={<SubRowCellHoverFooterDates record={record} />}
          footer={<SubRowCellHoverFooterWeekDays record={record} />}
        >
          <Box
            border={{ all: { color: 'purple1000', width: 's1', style: 'solid' } }}
            borderRadius={{ all: 'abs008' }}
            background="white"
            paddingY="s6"
            paddingX="s8"
            cursor="pointer"
            flexDirection="row"
            onClick={onClickSubRowCell}
          >
            <Text.Normal size="100" color="grey800" ellipsis>
              {cellText(record?.dailyMinutes || 0, record?.title)}
            </Text.Normal>
          </Box>
        </HoverScheduleCard>
      )}
    </Box>
  )
}

export default SubRowCell
